import axios from 'axios';

const isEnvDevelopment = process.env.NODE_ENV === 'development';

export function getWebserverConfigLocation() {
  if (isEnvDevelopment) return 'webserver.dev.json';
  return 'webserver.json';
}

export function getWebserverConfigPromise() {
  const webserver = getWebserverConfigLocation();
  return axios.get(`${webserver}?timestamp=${Date.now()}`);
}

export async function getWebserverConfigData() {
  const response = await getWebserverConfigPromise();
  return response.data;
}

export async function getLogConfig() {
  const config = await getWebserverConfigData();
  return {
    browserLogLevel: config?.logConfig?.browserLogLevel,
    logLevel: config?.logConfig?.logLevel,
    logMaxStackSize: config?.logConfig?.logMaxStackSize,
    logKey: config?.logConfig?.logKey,
    disableStoreLogger: config?.logConfig?.disableStoreLogger || false,
  };
}
